module.exports = __webpack_public_path__ + "static/media/icon_time.deefdfbc.svg";